export const CustomerQueryKeys = {
  all: () => ["customers"],
  single: (customerId: string) => [...CustomerQueryKeys.all(), customerId],
};
